import styles from './style.module.scss';
import { Col, Row, Spin, Typography } from 'antd';
import useStoreVsVillagePages from '../useSalesTrackingsGenderAge';
import BarChangeChart from '../../../charts/barChange';
import PrintFilterText from '../../printFiiterText';

const Print = ({
  allReports = false,
  allReportsData,
  isAllReports,
  isMain,
}) => {
  const { data, title, loading, searchParams, format, filters } =
    useStoreVsVillagePages(true, allReportsData, isAllReports);
  if (!isMain) {
    localStorage.setItem('auth_token', searchParams.get('token'));
  }

  const byPeriod = searchParams.get('by_period');
  const byShoppingCenter = searchParams.get('by_shopping_center');

  const searchParamsObj = Object.fromEntries([...searchParams]);
  const searchParamsObjKeys = Object.keys(searchParamsObj);
  const availableFilters = filters.filter((i) =>
    searchParamsObjKeys.includes(i.name),
  );

  return (
    <>
      <div className={styles.container}>
        {byPeriod && byShoppingCenter && (
          <Spin spinning={loading}>
            {!allReports && (
              <Row className={styles.titleSection} justify={'center'}>
                <Col>
                  <Typography.Title level={3}>{title}</Typography.Title>
                </Col>
                <PrintFilterText
                  availableFilters={availableFilters}
                  searchParams={searchParams}
                />
              </Row>
            )}
            {allReports && (
              <Row className={styles.titleSection} justify={'center'}>
                <Col>
                  <Typography.Title level={3}>
                    SALES TRACKING: age/gender
                  </Typography.Title>
                </Col>
              </Row>
            )}
            <br />
            <Row gutter={16}>
              <Col span={14}>
                <BarChangeChart
                  keys={['Sesso']}
                  data={data.chart1}
                  format={format}
                  lineItemWidth={180}
                  itemWidth={160}
                  translateX={200}
                  lineMargins={{ top: 50, right: 300, bottom: 100, left: 210 }}
                  lineAxisRightTickPadding={170}
                  lineTickSize={0}
                  lineFormat={(v) => `€${v}`}
                  lineMinValue={0}
                />
              </Col>
              <Col span={14}>
                <BarChangeChart
                  keys={['Maschi', 'Femmine']}
                  data={data.chart2}
                  format={format}
                  lineItemWidth={180}
                  itemWidth={160}
                  translateX={200}
                  hideLine
                />
              </Col>
              <Col span={14}>
                <BarChangeChart
                  keys={['Età ']}
                  data={data.chart3}
                  format={format}
                  lineItemWidth={180}
                  itemWidth={160}
                  translateX={200}
                  lineMargins={{ top: 50, right: 200, bottom: 100, left: 100 }}
                  lineAxisRightTickPadding={100}
                  lineTickSize={0}
                  lineFormat={(v) => `€${v}`}
                  lineMinValue={0}
                  hideMarker
                />
              </Col>
              <Col span={14}>
                <BarChangeChart
                  keys={['Incidenza per provincia']}
                  data={data.chart4}
                  format={format}
                  lineItemWidth={180}
                  itemWidth={160}
                  translateX={200}
                  hideMarker
                />
              </Col>
            </Row>
          </Spin>
        )}
      </div>
    </>
  );
};

export default Print;
